import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { EMPTY, Observable, catchError, throwError } from 'rxjs';

import { SessionExpiryService } from '../service/session-expiry.service';

const EXCLUDED_PATHS: readonly string[] = [
  '/api/auth/password-signin',
  '/api/auth/2fa',
  '/api/auth/magic-link-verify',
  '/api/auth/send-magic-link',
  '/api/auth/signup',
  '/api/auth/request-password-reset',
  '/api/auth/verify-password-reset',
  '/api/auth/reset-password',
  '/api/auth/heartbeat',
  '/api/auth/me',
];

export const SessionExpiredInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const sessionExpiry: SessionExpiryService = inject(SessionExpiryService);

  const isExcluded: boolean = EXCLUDED_PATHS.some((path: string): boolean =>
    request.url.includes(path),
  );

  if (isExcluded) {
    return next(request);
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        return throwError(() => error);
      }
      sessionExpiry.handle(error, 'interceptor');

      return EMPTY;
    }),
  );
};
